import { DatePipe } from '@angular/common';

import { DateFields, DateRange } from '../entities/date-range.entity';
import { ReduceToEnteredDateFields } from './date-range-granularity.helper';
import { PadLeft, ParseDateRangeQuery } from './date-range-query-helper';
import { FormatDate, MONTH_YEAR, YEAR } from './format-date.helper';

/**
 * Humanises one range bound, collapsing the inclusive-range expansion back to the granularity the user
 * entered (see {@link ReduceToEnteredDateFields}) so a year/month-only bound reads as `yyyy` / `MMM yyyy`
 * instead of the phantom expanded day.
 */
const GetDateString = (fields: DateFields, datePipe: DatePipe, isStart: boolean): string | null => {
    const entered = ReduceToEnteredDateFields(fields, isStart);
    const year: string | null = PadLeft(entered.Year, 4);
    const month: string | null = PadLeft(entered.Month, 2);
    const day: string | null = PadLeft(entered.Day, 2);

    if (!year) {
        return null;
    }

    if (!month) {
        return FormatDate(datePipe, `${year}-01-01`, YEAR);
    }

    if (!day) {
        return FormatDate(datePipe, `${year}-${month}-01`, MONTH_YEAR);
    }

    return FormatDate(datePipe, `${year}-${month}-${day}`);
};

export const TranslateDateRangeQuery = (
    query: string,
    fromLabel: string,
    toLabel: string,
    datePipe: DatePipe
): string => {
    const range: DateRange = ParseDateRangeQuery(query);
    const fromPart: string | null = GetDateString(range.From, datePipe, true);
    const toPart: string | null = GetDateString(range.Until, datePipe, false);

    if (fromPart && toPart) {
        return `${fromLabel} ${fromPart} ${toLabel.toLowerCase()} ${toPart}`;
    } else if (fromPart) {
        return `${fromLabel} ${fromPart}`;
    } else if (toPart) {
        return `${toLabel} ${toPart}`;
    } else {
        return '';
    }
};
